import React, { useCallback } from 'react'
import {
  ImageLoader,
} from '@usap/uicomponents'
import styled from 'styled-components'

import {
  Container,
  ImageText,
  ItemBox,
  ItemImageBox,
  NewBadge,
  ItemImageTextContainer,
} from './PartDisplay.css'

export interface PartDisplayProps {
  id: string,
  isBot: boolean,
  cloudinaryParams: string,
  imageSrc: string,
  imageText: string,
  alt: string,
  isNew: Boolean,
  Link: any,
  to: any,
  dualPartDisplay: boolean,
  skip?: boolean,
  elevation?: string,
  boxBgColor?: string,
  onItemClick?: () => void
}

export default function PartDisplay(props: PartDisplayProps) {
  const {
    id,
    isBot,
    elevation = 'none',
    boxBgColor = 'white',
    cloudinaryParams,
    imageSrc,
    imageText,
    alt = imageText,
    isNew,
    Link,
    to,
    dualPartDisplay,
    skip = false,
    onItemClick = () => {},
  } = props

  const StyledLink = styled(Link)`flex-grow: 1;`
  const onClick = useCallback(() => onItemClick(), [onItemClick])

  return (
    <Container
      id={id}
      elevation={elevation}
      background={boxBgColor}
      width={dualPartDisplay ? '50%' : '33.33%'}
    >
      {isNew && (
        <NewBadge>
          NEW
        </NewBadge>
      )}
      <StyledLink
        to={to}
        skip={skip}
        onClick={onClick}
      >
        <ItemBox>
          <ItemImageBox>
            <ImageLoader
              layout="fixed"
              height="100%"
              width="100%"
              fit="contain"
              src={imageSrc}
              alt={alt}
              cloudinaryParams={cloudinaryParams}
              isBot={isBot}
              noLazyLoad={!dualPartDisplay}
            />
          </ItemImageBox>
          <ItemImageTextContainer>
            <ImageText
              color="dark-2"
            >
              {imageText}
            </ImageText>
          </ItemImageTextContainer>
        </ItemBox>
      </StyledLink>
    </Container>
  )
}
